type SubtextProps = { text: string };

const OrderItemSubtext = ({ text }: SubtextProps) => <p className='font-italic text-xs'>{text}</p>;

export default OrderItemSubtext;
